import React from "react";
import AllContactsTable from "../Components/Pages/ContactUs/ContactsTable";
import Btn from "../Components/Pages/ContactUs/Btn";

function AllContacts() {
  return (
    <div>
      <div className="flex justify-between items-center py-7 px-10">
        <Btn />
      </div>
      <div className="px-10">
        <AllContactsTable />
      </div>
    </div>
  );
}

export default AllContacts;
